"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YoutubeService = void 0;
var Axios = __importStar(require("axios"));
function YouTubeGetID(url) {
    var ID = '';
    var newUrl = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if (newUrl[2] !== undefined) {
        ID = newUrl[2].split(/[^0-9a-z_-]/i);
        ID = ID[0];
    }
    else {
        ID = newUrl;
    }
    return ID;
}
exports.YoutubeService = function (url, key) {
    var newId = YouTubeGetID(url);
    return Axios.default
        .get("https://www.googleapis.com/youtube/v3/videos?part=id%2C+snippet&id=" + newId + "&key=" + key)
        .then(function (xhr) {
        var items = xhr.data.items;
        if (items.length > 0) {
            return {
                thumbnail: items[0].snippet.thumbnails.standard.url,
                description: items[0].snippet.description,
                title: items[0].snippet.title,
            };
        }
        return false;
    });
};
//# sourceMappingURL=youtube.service.js.map